import { Paper, Stack, Text, Button, Group } from '@mantine/core'

type Props = {
  onReset: () => void
  error: any
}

export function AppErrorFallback({ onReset, error }: Props) {
  console.log(error)
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <Paper p="xl" withBorder shadow="sm" radius="md" className="max-w-md">
        <Stack align="center" gap="md">
          <Text fw={600} size="xl">
            Something went wrong
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            An unexpected error occurred. Our team has been notified.
          </Text>
          <Group>
            <Button variant="default" onClick={() => (window.location.href = '/')}>
              Go Home
            </Button>
            <Button
              onClick={() => {
                onReset()
                window.location.reload()
              }}
            >
              Reload Page
            </Button>
          </Group>
        </Stack>
      </Paper>
    </div>
  )
}
